export default class StyledSelect {
    constructor(element) {
        this.element = element;
        this.select = element.querySelector('[data-styled-select-select]');
        this.label = element.querySelector('[data-styled-select-label]');

        this.updateLabel(this.selectedOption(this.select.selectedIndex).innerHTML);
        this.element.addEventListener('change', e => {
            this.updateLabel(this.selectedOption(e.target.selectedIndex).innerHTML);
        });

        this.element.addEventListener('mouseenter', this.mouseenter.bind(this));
        this.element.addEventListener('mouseleave', this.mouseleave.bind(this));
    }

    selectedOption(index) {
        if (index) {
            return this.select[index];
        }
        return this.select[0];
    }

    updateLabel(text) {
        if (this.label) {
            this.label.innerHTML = text;
        }
    }

    mouseenter() {
        this.element.setAttribute('data-is-hovered', true);
    }

    mouseleave() {
        this.element.removeAttribute('data-is-hovered');
    }
}
